/**
 * Shared DOM ids used for cross-component scrolling.
 *
 * Kept in its own dependency-free module on purpose: the pages that mark a
 * target and the component that scrolls to it would otherwise have to import
 * each other, which drags one's whole dependency tree (Analytics, the magnet
 * table) into the other's bundle for the sake of a string. Three copies of the
 * literal would just drift instead.
 */

/**
 * The download / gate block on each lead-magnet landing page.
 *
 * components/LeadConfirmed.tsx scrolls here after a confirmation click, because
 * confirming lands the visitor at the top of a long marketing page with the
 * thing they came for several screens below the fold — so without it the click
 * reads as "nothing happened". Every page carrying this id also needs
 * `scroll-mt-*` to clear the sticky header.
 */
export const LEAD_DOWNLOADS_ID = 'lead-downloads';
